"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareType = void 0;
var ShareType;
(function (ShareType) {
    ShareType["Main"] = "main";
    ShareType["Standard"] = "standard";
    ShareType["Device"] = "device";
    ShareType["Photo"] = "photo";
})(ShareType || (exports.ShareType = ShareType = {}));
//# sourceMappingURL=interface.js.map